import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row, Spinner, Tab, Tabs } from 'react-bootstrap';
import { UsersCard } from '../../component/Card/Statistics.card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faRefresh, faUser } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import { ClientService } from '../../component/services/client.service';
import toast from 'react-hot-toast';
import { makeParams } from '../../component/api/makeRequest';
import DataTable from '../../component/table/Invigilator.table';
import { saveAsCSV } from '../../component/helpers/csvhelper';
import moment from 'moment';
import TablePaginationComponent from '../../component/table/TablePagination';
import { ClientServiceV2 } from '../../component/services/client.service.v2';

export default function InvigilatorStatsIndex() {
    const [statsData, setStatsData] = useState<any>(null);
    const [statsCard, setStatsCard] = useState<any>({});
    const [centers, setCenters] = useState<any>([]);
    const [selectedCenters, setSelectedCenters] = useState<any>([]);
    const [shifts, setShifts] = useState<any>([]);
    const [selectedShift, setSelectedShift] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);


    const [pageNumber, setPageNumber] = useState<number>(1);
    const [pageSize, setPageSize] = useState<any>(10);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [key, setKey] = useState<any>('completed');


    const getUniqueCenter = async () => {
        try {
            const res = await ClientService.getUniqueCenter2(selectedShift);
            if (res.status === 200) {
                setCenters(
                    res.data?.centers.map((zone: any) => ({
                        value: zone?.centerPreference,
                        label: zone?.allocatedCenterId + " - " + zone?.centerPreference,
                    }))
                );
            }
        } catch (err: any) {
            toast.error(err.response?.data || 'Failed to fetch centers');
        }
    };

    const getAllShift = async () => {
        await ClientService.getAllShifts().then(res => {
            if (res.status === 200) {
                setShifts(res.data.shifts.map((data: any) => {
                    return {
                        label: data.shiftName + " - " + moment(data.startTime).format("DD MMM YYYY"),
                        value: data._id
                    }
                }))
            }
        }).catch(err => {
            toast.error(err.response.data);
        })
    }

    const getStats = async () => {
        const payload = {
            centerId: selectedCenters?.map((data: any) => data?.value),
        }
        setLoading(true);
        try {
            const res = await ClientServiceV2.getOperatorStats(selectedShift, key, pageNumber, pageSize, payload);
            if (res.status === 200) {
                setStatsData(res.data?.invigilatorProfiles);
                setTotalCount(res.data?.total);
                setStatsCard({
                    expected : res.data?.expected_count || 0,
                    completed : res.data?.completed || 0,
                    inprogress : res.data?.in_progress || 0,
                    pending: Math.max(Number(res.data?.expected_count || 0) - Number(res.data?.completed || 0), 0),
                })
            }
        } catch (err: any) {
            toast.error(err.response?.data || 'Failed to fetch stats');
        } finally {
            setLoading(false);
        }
    };

    const tabOptions = [
        { label: "Download Completed", value: "completed", iconClass: "fs-1 text-success" },
        // { label: "Download Pending", value: "pending", iconClass: "fs-1 text-warning" },
        // { label: "Logged-In Biometric Operators", value: "loggedin", iconClass: "fs-1 text-success" },
        // { label: "Total Biometric Operators", value: "total", iconClass: "fs-1" },
        { label: "In Progress", value: "inprogress", iconClass: "fs-1 text-primary" },
    ];

    const downloadCsv = (data: any[], fileName: string = 'data') => {
        if (!data?.length) {
            toast.error('No data found');
            return;
        }

        const csvData = [
            'Center,User Name,Email,Last Sync Time,Last Download Time,Download %,Upload %,Last Login Time,Last Logout Time',
            ...data.map((item: any) =>
                `${item?.centerId?.[0]},${item?.userName},${item?.emailId},${moment(item?.lastSyncedOn).format('DD-MM-YYYY hh:mm A')},${moment(item?.lastDownloadAt).format('DD-MM-YYYY hh:mm A')},${item?.meta.downloadStats.percentage},${item?.meta.uploadStats.percentage},${moment(item?.meta?.loginTimes?.slice(-1)?.[0]).format('DD-MM-YYYY hh:mm A')},${moment(item?.meta?.logoutTimes?.slice(-1)?.[0]).format('DD-MM-YYYY hh:mm A')}`
            ),
        ].join('\n');

        saveAsCSV(csvData, fileName);
    };


    const convertToCSV = (data: any) => {
        const csv = [];
        const columns = Object.keys(data[0]);
        csv.push(columns.join(','));

        data.forEach((item: any) => {
            const row = columns.map(col => item[col]);
            csv.push(row.join(','));
        });

        return csv.join('\n');
    };

    async function downloadNotStartedCSV() {
        setLoading(true);
        await ClientServiceV2.downloadNotStarted(selectedShift)
            .then(res => {
                if (res.status === 200) {
                    const blob = new Blob([res.data], { type: "text/csv" });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = "download_not_started.csv";
                    link.click();
                    URL.revokeObjectURL(url);
                }
            })
            .catch(e => {
                console.log(e);
                toast.error(e.response?.data?.message || e?.response?.data || "Something went wrong");
            })
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        if (selectedShift) {
            getStats();
        }
    }, [selectedCenters, selectedShift, key, pageNumber, pageSize]);

    useEffect(() => {
        if (selectedShift) {
            getUniqueCenter();
        }
    }, [selectedShift]);

    useEffect(() => {
        getAllShift();
    }, []);

    return (
        <>
            <>
                <Row className="mt-5 text-left">
                    <Col md={8}>
                        <h4 className="text-secondary">Device Report</h4>
                    </Col>
                    <Col md={4}>
                        <Form.Label className="text-muted fw-bold">
                            Select Shift
                        </Form.Label>
                        <Select
                            options={shifts}
                            placeholder="Select Shifts"
                            onChange={(e: any) => setSelectedShift(e?.value)}
                            isClearable
                            value={selectedShift ? shifts.find((shift: any) => shift.value === selectedShift.value) : null}
                        />
                    </Col>
                </Row>
                <Card className="mt-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '12px', border: 'none' }}>
                    <Card.Body>
                        <Row>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label className="text-muted fw-bold">Venue</Form.Label>
                                    <Select
                                        options={[{ label: 'All', value: 'All' }, ...(centers || [])]}
                                        onChange={(selectedOptions: any) => {
                                            if (selectedOptions?.some((option: any) => option.value === 'All')) {
                                                setSelectedCenters(centers);
                                            } else {
                                                setSelectedCenters(selectedOptions || []);
                                            }
                                        }}
                                        value={selectedCenters}
                                        isClearable
                                        isMulti
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Row className='mt-2'>
                    <div className="d-flex align-items-center justify-content-end">
                        <Button size="sm" onClick={downloadNotStartedCSV}>
                            <FontAwesomeIcon icon={faDownload} /> Download not started CSV
                        </Button>
                    </div>
                </Row>
                {loading &&
                    <div className="d-flex justify-content-center align-items-center my-3">
                        <Spinner animation="border" />
                    </div>
                }
                <Row className='mt-2'>
                    <div className="d-flex align-items-center justify-content-end">
                        <Button size="sm" onClick={getStats}>
                            <FontAwesomeIcon icon={faRefresh} /> Reload
                        </Button>
                    </div>
                </Row>
                <Row>
                    <Col md={3} className="mt-3">
                        <UsersCard
                            reactIcon={<FontAwesomeIcon icon={faUser} className="fs-1 text-primary" />}
                            header="Expected Operators"
                            statsValue={statsCard.expected || 0}
                        />
                    </Col>
                    <Col md={3} className="mt-3">
                        <UsersCard
                            reactIcon={<FontAwesomeIcon icon={faUser} className="fs-1 text-success" />}
                            header="Completed Downloads"
                            statsValue={statsCard.completed || 0}
                        />
                    </Col>
                    <Col md={3} className="mt-3">
                        <UsersCard
                            reactIcon={<FontAwesomeIcon icon={faUser} className="fs-1 text-warning" />}
                            header="In Progress"
                            statsValue={statsCard.inprogress || 0}
                        />
                    </Col>
                    <Col md={3} className="mt-3">
                        <UsersCard
                            reactIcon={<FontAwesomeIcon icon={faUser} className="fs-1 text-danger" />}
                            header="Pending"
                            statsValue={statsCard.pending || 0}
                        />
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Tabs
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-3"
                    >
                        {tabOptions.map(({ label, value, iconClass, index }: any) => (
                            <Tab eventKey={value} title={label} key={value}>
                                <div className="mt-2">
                                    <UsersCard
                                        reactIcon={<FontAwesomeIcon icon={faUser} className={iconClass} />}
                                        header="Count"
                                        statsValue={totalCount || 0}
                                    />
                                </div>
                                <div>
                                    <DataTable data={statsData} loading={loading} shiftId={selectedShift} />
                                </div>
                                <Row className='mt-2'>
                                    <Col>
                                        <TablePaginationComponent
                                            currentPage={pageNumber}
                                            itemsCount={totalCount}
                                            itemsPerPage={pageSize}
                                            setItemsPerPage={(e: any) => setPageSize(e)}
                                            setCurrentPage={setPageNumber}
                                        />
                                    </Col>
                                </Row>
                            </Tab>
                        ))}
                    </Tabs>
                </Row>
            </>
            {/* )} */}
        </>
    );
}

export function downloadCSV(csvData: any, fileName = 'data.csv') {
    if (!csvData) return;

    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}